import React, { Component } from 'react';
import Checkbox from 'material-ui/Checkbox';

import CheckboxOutlineIcon from 'material-ui/svg-icons/toggle/check-box-outline-blank';

import theme from '../../../muiTheme.js';

class MultiSelect extends Component {

  handleChange = (e, checked) => {
    this.props.onChange({
        value: e.target.value,
        add: checked
      });
  };

  render() {
    const codedValues = (this.props.codedValues) ? this.props.codedValues : [];

    let checkboxes = '';
    if(codedValues.length > 0) {
      checkboxes = codedValues.map((item, i) => {
          const itemStyle = {color: (this.props.selectedCodes.indexOf(item.code) !== -1 ? theme.palette.canvasColor : theme.palette.secondaryTextColor)};

          return (
            <Checkbox
              key={i}
              label={item.name}
              value={item.code}
              checked={this.props.selectedCodes.indexOf(item.code) !== -1}
              onCheck={this.handleChange}
              labelStyle={itemStyle}
              iconStyle={{fill: itemStyle.color}}
              uncheckedIcon={<CheckboxOutlineIcon />}
            />
          )
        });
      }

      return (
        <div className="filter-item selection-filter-item">
          {checkboxes}
        </div>
      );
  }

}

export default MultiSelect;
